class HHCurrencyForm extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    this.open = false

    if (this.isDesktop) {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', this.toggle.bind(this))
      })

      this.addEventListener('mouseenter', this.onOpen.bind(this))
      this.addEventListener('mouseleave', this.onClose.bind(this))
    }
  }

  onOpen () {
    this.classList.add('active')
    this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', true))
  }

  onClose () {
    this.classList.remove('active')
    this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', false))
  }

  toggle () {
    this.open = !this.open
    if (this.open) {
      this.onOpen()
    } else {
      this.onClose()
    }
  }

  onItemClick(event) {
    event.preventDefault();
    if (event.currentTarget.classList.contains('selected')) return;
    const form = this.querySelector('form');
    this.currencyInput.value = event.currentTarget.dataset.value;
    form?.submit();
  }

  get currencyInput () {
    return this.querySelector('input[name="currency"]')
  }

  get isDesktop () {
    return this.getAttribute('data-device') == 'desktop'
  }

  get triggers () {
    return this.querySelectorAll('.js-trigger')
  }
}

window.customElements.define('hh-currency-form', HHCurrencyForm)
